@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;
@use '@hevoio/hevo-ui-toolkit/styles/mixins' as hevo-toolkit-mixins;

.dropdownWrapper {
  height: 100%;

  .itemWrapper {
    display: flex;
    align-items: center;
    padding: hevo-toolkit-variables.$spacer * 0.5 hevo-toolkit-variables.$spacer;
    padding-right: hevo-toolkit-variables.$spacer * 2;
    min-height: 40px;
    cursor: pointer;

    .icon {
      display: none;
      width: 12px;
      color: hevo-toolkit-variables.$primary !important;
    }

    &.selected {
      background: hevo-toolkit-variables.$primary-faded !important;
      position: relative;

      .icon {
        display: unset;
        position: absolute;
        right: 10px;
      }
    }

    &.multipleSelected {
      background: hevo-toolkit-variables.$primary-faded;
      position: relative;
    }

    &:hover,
    &:focus {
      background: hevo-toolkit-variables.$hover-bg;
    }

    &.disabled {
      cursor: default;

      .textWrapper {
        color: hevo-toolkit-variables.$text-secondary !important;
      }
    }

    &.disabled .text {
      color: hevo-toolkit-variables.$text-secondary !important;
    }
  }

  &.helperDocumentRight {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  &.helperDocumentLeft {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }

  &.inlineDropdownWrapper {
    margin-bottom: 0px;
    border: 0px;
    border-radius: 0px;
    box-shadow: none;
  }
}

.textWrapper {
  line-height: hevo-toolkit-variables.$line-height-body !important;
  display: flex;
  align-items: center;
  gap: 5px;

  .text {
    color: hevo-toolkit-variables.$text-default !important;
    word-break: break-word;
  }
}

.caretIcon,
.clearIcon {
  padding: hevo-toolkit-variables.$spacer * 0.375;
  color: hevo-toolkit-variables.$text-default;
}

.popperShadow {
  box-shadow: hevo-toolkit-variables.$shadow-dropdown;
}

.selectModeDisplay {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  align-items: center;
  padding: hevo-toolkit-variables.$spacer 0 hevo-toolkit-variables.$spacer hevo-toolkit-variables.$spacer;
  right: 36px;
  cursor: pointer;
}

.autoCompletePopper {
  max-width: 500px;
}

.selectModeText {
  font-size: hevo-toolkit-variables.$font-size-body;
  color: hevo-toolkit-variables.$text-secondary;
}

.selectModeDisplaySmall {
  padding: hevo-toolkit-variables.$spacer * 0.75 0 hevo-toolkit-variables.$spacer * 0.75 hevo-toolkit-variables.$spacer;
}

.selectModeDisplayText {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.adornmentContainer {
  display: flex;
  width: 100%;
  align-items: center;
}

.popperRoot {
  z-index: hevo-toolkit-variables.$zindex-modal !important;
}

.adornmentWrapper {
  display: flex;
  align-items: center;
  font-weight: hevo-toolkit-variables.$font-weight-medium;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: hevo-toolkit-variables.$shadow-default;
  padding: hevo-toolkit-variables.$spacer * 0.75 hevo-toolkit-variables.$spacer;
  text-align: left;
  justify-content: flex-start;
  width: 100%;
  z-index: 1;

  .link {
    width: 100%;
    text-decoration: none !important;
    box-shadow: none;

    &:hover {
      color: hevo-toolkit-variables.$text-primary !important;
    }
  }
}

.save {
  color: hevo-toolkit-variables.$text-primary;
}

.loader {
  display: flex;
  justify-content: end;
  align-items: center;
  width: fit-content;
  min-width: fit-content;
  color: hevo-toolkit-variables.$text-primary;
  @include hevo-toolkit-mixins.spinning-animation('.icon', 2s);
}

.helperWindow {
  width: 180px;
  max-height: 226px;
  border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  background: hevo-toolkit-variables.$surface-bg-secondary;
}

.helperWindowLeft {
  border-top-left-radius: hevo-toolkit-variables.$border-radius-md;
  border-bottom-left-radius: hevo-toolkit-variables.$border-radius-md;
  border-right: 0px;
}

.helperWindowRight {
  border-top-right-radius: hevo-toolkit-variables.$border-radius-md;
  border-bottom-right-radius: hevo-toolkit-variables.$border-radius-md;
  border-left: 0px;
}

.multiSelectHelperWindow {
  width: 180px;
  background: hevo-toolkit-variables.$surface-bg-secondary;
  border-left: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
}

.hideInput {
  width: 0px !important;
  padding: 0px !important;
}

.optionTagsWrapper {
  display: flex;
  width: 100%;

  .tagsWrapper {
    display: flex;
    flex-wrap: wrap;
    margin: hevo-toolkit-variables.$spacer * 0.56 0px;
    max-height: 32px;
    width: 100%;
    overflow: hidden;

    &.scrollableTagsWrapper {
      max-height: 64px;
      overflow: auto;
    }

    .optionTags {
      margin: hevo-toolkit-variables.$spacer * 0.125 hevo-toolkit-variables.$spacer * 0.25;
      margin-left: 0px;

      .tag {
        margin-left: 0px;
        justify-content: space-between;
        min-width: auto;
      }
    }
  }

  .optionLeftOutTagsWrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .optionLeftOutTags {
      color: hevo-toolkit-variables.$info;
      background: hevo-toolkit-variables.$info-alert-bg;
      border: 0px;
      margin: hevo-toolkit-variables.$spacer * 0.65 0px;
      margin-right: hevo-toolkit-variables.$spacer * 0.25;
      border-radius: hevo-toolkit-variables.$border-radius-default;
    }
  }
}
